import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Star, Search } from 'lucide-react';
import { Input } from '../components/ui/input';
import api, { enrichAgent } from '../lib/api';

export default function Agents() {
  const [q, setQ] = useState('');
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    api.get('/agents').then(r => setAgents((r.data || []).map(enrichAgent)));
  }, []);

  const filtered = agents.filter(a => a.name.toLowerCase().includes(q.toLowerCase()) || (a.title || '').toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="bg-neutral-50 min-h-screen">
      <div className="bg-gradient-to-r from-neutral-900 to-neutral-800 text-white">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <h1 className="text-3xl md:text-4xl font-bold">Our Real Estate Advisors</h1>
          <p className="text-neutral-300 mt-2 max-w-2xl">Connect with licensed professionals who know the Philippine real estate market inside and out.</p>
          <div className="mt-6 max-w-md relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search advisors by name or specialty" className="pl-9 bg-white text-neutral-900" />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((a) => (
            <div key={a.id} className="bg-white rounded-xl border border-neutral-200 overflow-hidden card-hover">
              <div className="aspect-square overflow-hidden">
                <img src={a.photo} alt={a.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-bold text-lg text-neutral-900">{a.name}</h3>
                  <div className="flex items-center gap-1 text-sm"><Star className="w-4 h-4 fill-[#DC2626] text-[#DC2626]" /> <span className="font-semibold">{a.rating}</span></div>
                </div>
                <p className="text-sm text-[#DC2626] font-medium">{a.title}</p>
                <p className="text-xs text-neutral-500 mt-1">{a.license}</p>
                <p className="mt-3 text-sm text-neutral-700 line-clamp-2">{a.bio}</p>
                <div className="mt-4 grid grid-cols-3 gap-2 text-center text-xs">
                  <div className="p-2 bg-neutral-50 rounded"><p className="font-bold text-neutral-900">{a.listings}</p><p className="text-neutral-500">Active</p></div>
                  <div className="p-2 bg-neutral-50 rounded"><p className="font-bold text-neutral-900">{a.sold}</p><p className="text-neutral-500">Sold</p></div>
                  <div className="p-2 bg-neutral-50 rounded"><p className="font-bold text-neutral-900">{a.rating}</p><p className="text-neutral-500">Rating</p></div>
                </div>
                <div className="mt-4 pt-4 border-t border-neutral-100 flex items-center justify-between text-sm">
                  <a href={'tel:' + a.phone} className="flex items-center gap-1 text-neutral-700 hover:text-[#DC2626]"><Phone className="w-4 h-4" /> Call</a>
                  <a href={'mailto:' + a.email} className="flex items-center gap-1 text-neutral-700 hover:text-[#DC2626]"><Mail className="w-4 h-4" /> Email</a>
                  <Link to={'/agent/' + a.id} className="text-[#DC2626] font-semibold hover:underline">View Profile</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
